import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from './HashMap.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EmptyHolderClass;
function EmptyHolder() {
  if (EmptyHolderClass === VOID) {
    class $ {
      constructor() {
        EmptyHolder_instance = this;
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = InternalHashMap().ja(0);
        this_0.ac();
        tmp.dc_1 = LinkedHashMap().ec(this_0);
      }
    }
    initMetadataForObject($, 'EmptyHolder');
    EmptyHolderClass = $;
  }
  return EmptyHolderClass;
}
var EmptyHolder_instance;
function EmptyHolder_getInstance() {
  if (EmptyHolder_instance === VOID)
    new (EmptyHolder())();
  return EmptyHolder_instance;
}
function init_kotlin_collections_LinkedHashMap(_this__u8e3s4) {
}
var LinkedHashMapClass;
function LinkedHashMap() {
  if (LinkedHashMapClass === VOID) {
    class $ extends HashMap() {
      static f6() {
        var $this = this.n8();
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static fc(initialCapacity) {
        var $this = this.b9(initialCapacity);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static gc(original) {
        var $this = this.c9(original);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static ec(internalMap) {
        var $this = this.m8(internalMap);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      c8() {
        this.k8_1.ac();
        var tmp;
        if (this.p1() > 0) {
          tmp = this;
        } else {
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp = EmptyHolder_getInstance().dc_1;
        }
        return tmp;
      }
      k6() {
        return this.k8_1.n9();
      }
    }
    initMetadataForClass($, 'LinkedHashMap', $.f6, VOID, [HashMap(), KtMutableMap()]);
    LinkedHashMapClass = $;
  }
  return LinkedHashMapClass;
}
//region block: exports
export {
  LinkedHashMap as LinkedHashMap1zhqxkxv3xnkl,
};
//endregion

//# sourceMappingURL=LinkedHashMap.mjs.map
